/**
 * Yamiward — storefront conversion layer.
 * Owns the size guide modal (snippets/size-guide.liquid, on every page) and the clan hand-off
 * to the game. The header and its menus are assets/shell.js's.
 * Also window.YW_JAPAN: the one browser copy of the Japan Express rule.
 */

/* ---------- Japan Express: sold in the Japan market only (plan Task 2.5, decision D3) ----------
   The Ward page's rails (assets/japan.js, clans.js, shrine.js) read /products.json and add to the bag; all three ask
   this, so the rule cannot drift between them. The Liquid copy is snippets/is-japan-express.liquid.
   Japan Express: a fulfil-japan tag (any case), or, until the catalogue tags are live, "Japan Express" in the title.
   Fail-closed: outside Japan, or with Shopify.country unknown, a Japan Express product is never offered. A rail that
   finds no YW_JAPAN (this file failed to load) offers nothing at all. */
window.YW_JAPAN = (function () {
    function hasTag(p, tag) {
        var tags = (p && p.tags) || [];
        if (typeof tags === "string") tags = tags.split(",");
        for (var i = 0; i < tags.length; i++) {
            if (String(tags[i]).trim().toLowerCase() === tag) return true;
        }
        return false;
    }
    function isJapanExpress(p) {
        if (hasTag(p, "fulfil-japan")) return true;
        // title fallback: remove after catalogue tags are live (plan Task 2.2 Step 5)
        return String((p && p.title) || "").toLowerCase().indexOf("japan express") > -1;
    }
    function inJapan() {
        return !!(window.Shopify && window.Shopify.country === "JP");
    }
    function sellsHere(p) {
        return inJapan() || !isJapanExpress(p);
    }
    return { isJapanExpress: isJapanExpress, inJapan: inJapan, sellsHere: sellsHere };
})();

document.addEventListener("DOMContentLoaded", () => {
    /* ---------- Size guide modal ---------- */

    const overlay = document.getElementById("size-guide-overlay");
    const modal = document.getElementById("size-guide-modal");
    const closeBtn = document.getElementById("size-guide-close");
    const tabs = modal ? Array.from(modal.querySelectorAll(".size-guide-tab")) : [];
    const unitBtns = modal ? Array.from(modal.querySelectorAll(".size-guide-unit")) : [];
    let lastFocused = null;

    function showTab(name) {
        tabs.forEach((t) => {
            const on = t.getAttribute("data-tab") === name;
            t.classList.toggle("active", on);
            t.setAttribute("aria-selected", on ? "true" : "false");
        });
        ["tee", "hoodie"].forEach((k) => {
            const panel = document.getElementById("size-panel-" + k);
            if (panel) panel.hidden = k !== name;
        });
    }

    function showUnit(unit) {
        unitBtns.forEach((b) => b.classList.toggle("active", b.getAttribute("data-unit") === unit));
        if (!modal) return;
        modal.querySelectorAll("td[data-in]").forEach((td) => {
            const raw = td.getAttribute(unit === "cm" ? "data-cm" : "data-in");
            td.textContent = unit === "cm" ? raw + " cm" : raw + '"';
        });
    }

    function openGuide(which) {
        if (!modal || !overlay) return;
        lastFocused = document.activeElement;
        showTab(which === "hoodie" ? "hoodie" : "tee");
        overlay.hidden = false;
        modal.hidden = false;
        document.body.classList.add("size-guide-open");
        if (closeBtn) closeBtn.focus();
    }

    function closeGuide() {
        if (!modal || !overlay) return;
        overlay.hidden = true;
        modal.hidden = true;
        document.body.classList.remove("size-guide-open");
        if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
    }

    if (modal) {
        showUnit("in");
        tabs.forEach((t) => t.addEventListener("click", () => showTab(t.getAttribute("data-tab"))));
        unitBtns.forEach((b) => b.addEventListener("click", () => showUnit(b.getAttribute("data-unit"))));
        if (closeBtn) closeBtn.addEventListener("click", closeGuide);
        if (overlay) overlay.addEventListener("click", closeGuide);
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && !modal.hidden) closeGuide();
        });

        // Delegated so cards rendered later by clans.js / shrine.js / japan.js work too.
        document.addEventListener("click", (e) => {
            const trigger = e.target.closest("[data-size-guide]");
            if (!trigger) return;
            e.preventDefault();
            openGuide(trigger.getAttribute("data-size-guide"));
        });

        // Anything else on the page can ask for it, e.g. the fit finder.
        window.YamiwardSizeGuide = { open: openGuide, close: closeGuide };
    }
});

/* ---------- Clan hand-off to the game ---------- */
// play.yamiward.com is another origin and cannot read this one's storage, so the
// store passes the visitor's bloodline in the link: &clan=<key>, read from yw_clan.
// It is applied on load and again at click time (a bloodline declared after the page
// loaded still counts). Only a value shaped like a clan key is ever appended, and the
// link's own utm_* parameters stay.
(function () {
    var SELECTOR = 'a[href*="play.yamiward.com"]';

    function storedClan() {
        try {
            var key = JSON.parse(window.YW_STORE.get("yw_clan")).key;
            return typeof key === "string" && /^[a-z]{2,16}$/.test(key) ? key : null;
        } catch (e) { return null; } // nothing stored, not JSON, or no store
    }

    function tag(a) {
        try {
            var url = new URL(a.href);
            if (url.hostname !== "play.yamiward.com") return;
            var clan = storedClan();
            if (!clan) return;
            url.searchParams.set("clan", clan);
            a.href = url.href;
        } catch (e) { /* leave the link as it is */ }
    }

    function tagClicked(e) {
        var a = e.target && e.target.closest && e.target.closest(SELECTOR);
        if (a) tag(a);
    }

    ["click", "auxclick", "contextmenu"].forEach(function (type) { document.addEventListener(type, tagClicked, true); });

    function tagAll() { document.querySelectorAll(SELECTOR).forEach(tag); }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", tagAll);
    else tagAll();
})();
